import { render, staticRenderFns } from "./combineBill.vue?vue&type=template&id=1650d2a8&scoped=true&"
import script from "./combineBill.vue?vue&type=script&lang=js&"
export * from "./combineBill.vue?vue&type=script&lang=js&"
import style0 from "./combineBill.vue?vue&type=style&index=0&id=1650d2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650d2a8",
  null
  
)

export default component.exports